const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatWithoutRound, formatCurrency } = require('utilities/currencyHelper');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

class WalletValues extends React.Component {
    constructor(props) {
        super(props);
    }

    getTotalValueGeneralView() {
        const { immMyWalletCharts } = this.props;
        const actualValueGeneral = formatWithoutRound(immMyWalletCharts.getIn(['consolidatedValueGeneral', 'amount']), 2);
        const actualValueCurrencyGeneral = formatCurrency(immMyWalletCharts.getIn(['totalValueGeneral', 'currency']));
        const actualValueFormattedGeneral = `${actualValueGeneral} ${actualValueCurrencyGeneral}`;
        return (
            <div className="my-wallet-actual-tab__amount-general">
                <FormattedText value="myWallet-amountGeneralView" injectedStrings={[actualValueFormattedGeneral]} />
            </div>
        );
    }

    buildInvestedCapital() {
        const { immMyWalletCharts } = this.props;
        const canDisplayInvestment = immMyWalletCharts.get('canDisplayInvestment');
        const canDisplayProfitability = immMyWalletCharts.get('canDisplayProfitability');

        let investedCapitalLabel;

        if (canDisplayInvestment && canDisplayProfitability) {
            const investment = formatWithoutRound(immMyWalletCharts.getIn(['totalInvestment', 'amount']), 2);
            const investmentCurrency = formatCurrency(immMyWalletCharts.getIn(['totalInvestment', 'currency']));
            const investmentFormatted = `${investment} ${investmentCurrency}`;

            investedCapitalLabel = (
                <span className="my-wallet-actual-tab__investment">
                    {investmentFormatted}
                </span>
            );
        } else {
            investedCapitalLabel = (
                <span className="my-wallet-actual-tab__investment">
                    <FormattedText value="broker-myInvestmentsNotAvailableInitials" />
                </span>
            );
        }

        return investedCapitalLabel;
    }

    buildProfitability() {
        const { immMyWalletCharts } = this.props;
        const canDisplayInvestment = immMyWalletCharts.get('canDisplayInvestment');
        const canDisplayProfitability = immMyWalletCharts.get('canDisplayProfitability');

        let profitabilityLabel;

        if (canDisplayInvestment && canDisplayProfitability) {
            const profitability = formatWithoutRound(immMyWalletCharts.getIn(['totalProfitability', 'amount']), 2);
            const profitabilityCurrency = formatCurrency(immMyWalletCharts.getIn(['totalProfitability', 'currency']));
            const profitabilityFormatted = `${profitability} ${profitabilityCurrency}`;

            const profitabilityPercentage = immMyWalletCharts.get('totalProfitabilityPercentage');
            const profitPercentageFormatted = formatWithoutRound(profitabilityPercentage, 2);

            profitabilityLabel = (
                <span>
                    <span className="my-wallet-actual-tab__profitability">
                        {profitabilityFormatted}
                    </span>
                    <span className="my-wallet-actual-tab__amount-percentage">
                        {profitPercentageFormatted}%
                    </span>
                </span>
            );
        } else {
            profitabilityLabel = (
                <span className="my-wallet-actual-tab__profitability">
                    <FormattedText value="broker-myInvestmentsNotAvailableInitials" />
                </span>
            );
        }

        return profitabilityLabel;
    }

    buildActualValue() {
        const { immMyWalletCharts, immBrokerMyInvestments } = this.props;
        const totalValue = immMyWalletCharts.get('consolidatedValueGeneral', null);
        const currentValue = immBrokerMyInvestments.getIn(['totalSummarizedValues', 'summarizedValor'], null);
        if (!!totalValue && !!totalValue.get('currency') && currentValue) {
            const moneda = formatCurrency(totalValue.get('currency'));
            return `${formatWithoutRound(currentValue, 2)} ${moneda}`;
        }
        return formatText('broker-myInvestmentsNotAvailableInitials');
    }

    render() {
        const { immMyWalletCharts } = this.props;
        const actualValue = this.buildActualValue();
        const actualRentability = this.buildProfitability();
        const investedCapital = this.buildInvestedCapital();
        const actualValueTitle = formatText('myWallet-value');
        const rentabilityTitle = formatText('myWallet-rentability');
        const capitalTitle = formatText('myWallet-capital');

        const hasPendingOperations = immMyWalletCharts.get('hasPendingOperations');
        const pendingOperationsLabel = hasPendingOperations ? <FormattedText value="brokerMyWallet-pendingRentabilityOperations" /> : null;

        const isCustomWalletSelected = immMyWalletCharts.get('isCustomWalletSelected');
        const totalValueGeneral = isCustomWalletSelected ? this.getTotalValueGeneralView() : null;

        return (
            <div className="my-wallet-actual-tab__info-container">
                <div className="my-wallet-actual-tab__main-values">
                    <div className="my-wallet-actual-tab__main-value col-lg-5">
                        <span className="my-wallet-actual-tab__title">
                            {actualValueTitle}
                        </span>
                        <span className="my-wallet-actual-tab__amount my-wallet-actual-tab__actual-value">
                            {actualValue}
                        </span>
                        {totalValueGeneral}
                    </div>
                    <div className="my-wallet-actual-tab__main-value col-lg-7">
                        <div className="my-wallet-actual-tab__title--tooltip">
                            <span className="my-wallet-actual-tab__title">
                                {rentabilityTitle}
                            </span>
                        </div>
                        <span className="my-wallet-actual-tab__amount">
                            {actualRentability}
                        </span>
                        <span className="my-wallet-actual-tab__pending-operations">
                            {pendingOperationsLabel}
                        </span>
                    </div>
                </div>
                <div className="my-wallet-actual-tab__capital">
                    <span className="my-wallet-actual-tab__capital-title">
                        {capitalTitle}
                    </span>
                    <span className="my-wallet-actual-tab__capital-amount">
                        {investedCapital}
                    </span>
                </div>
                <OKLink
                    modifier="emphasize"
                    onClick={this.props.handleHowCalculateOnClick}
                >
                    <FormattedText value="brokerCalculateMyWalletModal-link" />
                </OKLink>
            </div>
        );
    }
}

WalletValues.propTypes = {
    immMyWalletCharts: PropTypes.object.isRequired,
    handleHowCalculateOnClick: PropTypes.func.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
};

module.exports = WalletValues;
